import { useEffect, useRef, useState, useCallback, useContext, useMemo } from 'react';
import { getDimensions, eventDimension } from '../../hybrid/wrappers';
import { getIsOpera, getIsSafari } from './utils';
import breakpoints from '../../project/uikit/media.module.scss';
const project = require('../../scripts/configs/project');
import UserContext from './getContext';

export const useWindowDimensions = (withoutZoom) => {
    const [windowDimensions, setWindowDimensions] = useState();

    useEffect(() => {
        function handleResize() {
            const { width } = getDimensions(withoutZoom);
            setWindowDimensions(width);
        }
        handleResize();
        eventDimension(handleResize);
        return () => eventDimension(handleResize, true);
    }, [withoutZoom]);
    return windowDimensions;
};

// Для обмеження кода тільки на клієнті
export const useClient = () => {
    const [client, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);
    return client;
};

export const useWindowDimensionsSafari = () => {
    const [windowDimensions, setWindowDimensions] = useState();

    useEffect(() => {
        function handleResize() {
            let isSafari =
                /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
                /constructor/i.test(window.HTMLElement) ||
                (function (p) {
                    return p.toString() === '[object SafariRemoteNotification]';
                })(
                    !window['safari'] ||
                        // eslint-disable-next-line no-undef
                        (typeof safari !== 'undefined' && safari.pushNotification)
                );
            let { width } = getDimensions();
            let dimension = width;

            let scrollWidth = 0;
            if (isSafari) {
                if (width > document.documentElement.clientWidth && width > 991) {
                    dimension = document.documentElement.clientWidth;
                }
                if (document.querySelector('html').dataset.uscrollable) {
                    const paddingRight = document.querySelector('html').style.getPropertyValue('padding-right');
                    if (paddingRight) {
                        const paddingRightNum = Number(paddingRight.replace('px', ''));
                        if (paddingRightNum === paddingRightNum) {
                            scrollWidth = paddingRightNum;
                        }
                    }
                }
            }
            dimension = dimension - scrollWidth;

            setWindowDimensions(dimension);
        }
        handleResize();
        eventDimension(handleResize);
        return () => eventDimension(handleResize, false);
    }, []);

    return windowDimensions;
};
export const getBoundingTopSafari = (element) => {
    // TODO ZOOM
    const picker = element.getBoundingClientRect();
    let isSafari =
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
        /constructor/i.test(window.HTMLElement) ||
        (function (p) {
            return p.toString() === '[object SafariRemoteNotification]';
        })(
            !window['safari'] ||
                // eslint-disable-next-line no-undef
                (typeof safari !== 'undefined' && safari.pushNotification)
        );
    if (isSafari) {
        var getWithZoom = (scroll) => {
            let width = window.innerWidth;
            const zoom = Number(window.getComputedStyle(document.querySelector('html'), null).zoom);
            if (project.zooming && zoom === zoom && zoom < 1 && width < 1650 && width >= 1300) {
                return scroll / zoom;
            }
            return scroll;
        };
        return picker.top - (getWithZoom(window?.scrollY) - window?.scrollY);
    }
    // TODO ZOOM
    return picker.top;
};
export const useWindowDimensionsHeight = () => {
    const [windowDimensions, setWindowDimensions] = useState();

    useEffect(() => {
        function handleResize() {
            const { height } = getDimensions();
            setWindowDimensions(height);
        }
        handleResize();
        eventDimension(handleResize);
        return () => eventDimension(handleResize, false);
    }, []);

    return windowDimensions;
};

export const useWindowScrollDimensions = (func) => {
    useEffect(() => {
        window.addEventListener('scroll', func);

        return () => {
            window.removeEventListener('scroll', func);
        };
    }, [func]);
};

// @TODO refactor to use
export const WindowScrollDimensions = (func, remove) => {
    !!remove ? window.removeEventListener('scroll', func) : window.addEventListener('scroll', func);

    return () => {
        window.removeEventListener('scroll', func);
    };
};

export const useUnscrollableBody = (on, key, turnOffResize, unscrollable = true) => {
    const scrollValue = useRef();

    const turnOn = useCallback(() => {
        const prevData = document.querySelector('html').dataset.uscrollable;
        const prevDataArr = prevData ? prevData.split(',') : [];

        if (window.innerWidth < 768) {
            const scroll = scrollY;
            document.querySelector('html').dataset.uscrollable = [...prevDataArr, key].join(',');
            if (scroll) {
                document.querySelector('body').scrollTo({
                    top: scroll,
                    left: scrollX,
                    behavior: 'instant'
                });
                scrollValue.current = scroll;
            }
        } else {
            const padding = window.innerWidth - document.documentElement.clientWidth;
            document.querySelector('html').dataset.uscrollable = [...prevDataArr, key].join(',');
            if (padding) {
                document.querySelector('html').style.paddingRight = `${padding}px`;
            }
        }
    }, [key]);

    const turnOff = useCallback(() => {
        const prevData = document.querySelector('html').dataset.uscrollable;
        const prevDataArr = prevData && prevData.split(',');
        const newData = prevDataArr && prevDataArr.filter((i) => i !== key);

        if (newData && newData?.length) {
            document.querySelector('html').dataset.uscrollable = newData.join(',');
        } else {
            document.querySelector('html').style.paddingRight = '';
            document.querySelector('html').removeAttribute(`data-uscrollable`);
            if (window.innerWidth < 768 && scrollValue.current) {
                document.querySelector('html').scrollTo({
                    top: scrollValue.current,
                    left: scrollX,
                    behavior: 'instant'
                });
            }
        }
    }, [key]);

    useEffect(() => {
        if (unscrollable) {
            if (on) {
                turnOn();
            } else {
                turnOff();
            }
            return () => {
                turnOff();
            };
        }
    }, [on, unscrollable, turnOn, turnOff]);

    useEffect(() => {
        if (unscrollable) {
            if (turnOffResize) {
                const resetMenuEffect = () => {
                    turnOff();
                    turnOffResize(false);
                };

                window.addEventListener('resize', resetMenuEffect, false);

                return () => {
                    window.removeEventListener('resize', resetMenuEffect, false);
                    turnOff();
                };
            }
        }
    }, [turnOffResize, turnOff, unscrollable]);
    return on;
};

// Нівелює onClick, коли елемент перетаскується (наприклад в слайдері), повертає обробники, які треба застосувати на елементі
// onNotScroll - onClick функція
export const useDisableClickOnDrag = (callback) => {
    const windowScrollX = useRef(0);
    const windowScrollY = useRef(0);

    const touchStartX = useRef(0);
    const touchStartY = useRef(0);
    const scrolling = useRef(false);

    const mouseStartX = useRef(0);
    const mouseStartY = useRef(0);

    const handleTouchStart = useCallback((event) => {
        const touch = event.touches[0];

        windowScrollX.current = window.scrollX;
        windowScrollY.current = window.scrollY;

        if (touch) {
            touchStartX.current = touch.clientX;
            touchStartY.current = touch.clientY;
            scrolling.current = false;
        }
    }, []);

    const handleTouchMove = useCallback((event) => {
        const isWindowScrolled = window.scrollY !== windowScrollY.current || window.scrollX !== windowScrollX.current;

        if (isWindowScrolled) {
            scrolling.current = true;
        } else {
            const touch = event.touches && event.touches[0];
            if (touch) {
                const deltaX = Math.abs(touch.clientX - touchStartX.current);
                const deltaY = Math.abs(touch.clientY - touchStartY.current);

                const isScrolling = deltaX !== deltaY;
                if (isScrolling) {
                    scrolling.current = true;
                } else {
                    scrolling.current = false;
                }
            }
        }
    }, []);
    const handleTouchEnd = useCallback(
        (event) => {
            if (!scrolling.current && callback) {
                callback(event);
            }
        },
        [callback]
    );
    const handleMouseDown = useCallback((event) => {
        mouseStartX.current = event.clientX;
        mouseStartY.current = event.clientY;
    }, []);
    const handleMouseUp = useCallback(
        (event) => {
            const deltaX = Math.abs(event.clientX - mouseStartX.current);
            const deltaY = Math.abs(event.clientY - mouseStartY.current);

            const isScrolling = deltaX !== deltaY;
            if (!isScrolling && callback) {
                callback(event);
            }
        },
        [callback]
    );
    const handleClick = useCallback((event) => {
        const deltaX = Math.abs(event.clientX - mouseStartX.current);
        const deltaY = Math.abs(event.clientY - mouseStartY.current);

        const isScrolling = deltaX !== deltaY;

        if (scrolling.current || isScrolling) {
            event.preventDefault();
        }
    }, []);
    return {
        allEvents: {
            onMouseDown: handleMouseDown,
            onMouseUp: handleMouseUp,
            onTouchStart: handleTouchStart,
            onTouchMove: handleTouchMove,
            onTouchEnd: handleTouchEnd,
            onClick: handleClick
        },
        handleClick,
        handleMouseUp,
        handleMouseDown,
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd
    };
};

// Використовується для прилипання вспливаючого елемента до іншого і приховування при кліку зовні
// pickerElement - елемент, до якого прилипання (ref)
// onScrollHandler - функція з розрахунками положення вспливаючого елемента
// pickerElement - вспливаючий елемент (ref)
// handleClose - функція приховування
// disableListeners - якщо true - всі обробники зачищаються
// otherDeps - якщо треба викликати onScrollHandler повторно
export const usePopupListeners = (
    pickerElement,
    onScrollHandler,
    modalElement,
    handleClose,
    disableListeners = false,
    otherDeps = false
) => {
    const onNotScroll = useCallback(
        (event) => {
            if (event.changedTouches) {
                const touchEndX = event.changedTouches[0].clientX;
                const touchEndY = event.changedTouches[0].clientY;

                function isInsideElement(element) {
                    const elementRect = element.getBoundingClientRect();

                    return (
                        touchEndX >= elementRect.left &&
                        touchEndX <= elementRect.right &&
                        touchEndY >= elementRect.top &&
                        touchEndY <= elementRect.bottom
                    );
                }
                if (pickerElement.current && isInsideElement(pickerElement.current)) {
                    return;
                }
                if (modalElement.current && isInsideElement(modalElement.current)) {
                    return;
                }

                handleClose();
            }
        },
        [handleClose, modalElement, pickerElement]
    );
    const { handleTouchStart, handleTouchMove, handleTouchEnd } = useDisableClickOnDrag(onNotScroll);

    useEffect(() => {
        if (pickerElement.current) {
            const onClickOutsideFunc = (e) => {
                let isSafari = getIsSafari();
                let isOpera = getIsOpera();

                var getWithZoom = (mouse) => {
                    let width = window.innerWidth;
                    const zoom = Number(window.getComputedStyle(document.querySelector('html'), null).zoom);
                    if (zoom === zoom && zoom < 1 && width < 1650 && width >= 1300) {
                        return mouse / zoom;
                    }
                    return mouse;
                };
                var clickX = isSafari || isOpera ? getWithZoom(e.clientX) : e.clientX;
                var clickY = isSafari || isOpera ? getWithZoom(e.clientY) : e.clientY;

                function isInsideElement(element) {
                    var elementRect = element.getBoundingClientRect();
                    var elementX = elementRect.left;
                    var elementY = getBoundingTopSafari(element);
                    var elementWidth = elementRect.width;
                    var elementHeight = elementRect.height;

                    if (
                        clickX >= elementX &&
                        clickX <= elementX + elementWidth &&
                        clickY >= elementY &&
                        clickY <= elementY + elementHeight
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                }

                if (pickerElement.current && isInsideElement(pickerElement.current)) {
                    return;
                }
                if (modalElement.current && isInsideElement(modalElement.current)) {
                    return;
                }
                handleClose();
            };
            const scrollOn = pickerElement.current.closest('[data-scroll]') || window;

            if (disableListeners) {
                if (onScrollHandler) {
                    scrollOn.removeEventListener('scroll', onScrollHandler);
                }
                document.body.removeEventListener('click', onClickOutsideFunc);

                document.removeEventListener('touchstart', handleTouchStart);
                document.removeEventListener('touchmove', handleTouchMove);
                document.removeEventListener('touchend', handleTouchEnd);
            } else {
                if (onScrollHandler) {
                    scrollOn.addEventListener('scroll', onScrollHandler);
                }
                document.body.addEventListener('click', onClickOutsideFunc);

                document.addEventListener('touchstart', handleTouchStart);
                document.addEventListener('touchmove', handleTouchMove);
                document.addEventListener('touchend', handleTouchEnd);
            }

            return () => {
                if (onScrollHandler) {
                    scrollOn.removeEventListener('scroll', onScrollHandler);
                }
                document.body.removeEventListener('click', onClickOutsideFunc);

                document.removeEventListener('touchstart', handleTouchStart);
                document.removeEventListener('touchmove', handleTouchMove);
                document.removeEventListener('touchend', handleTouchEnd);
            };
        }
    }, [
        onScrollHandler,
        handleClose,
        modalElement,
        disableListeners,
        pickerElement,
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd
    ]);

    useEffect(() => {
        if (onScrollHandler) {
            onScrollHandler();
        }
    }, [otherDeps, onScrollHandler]);

    return null;
};
export const useBreakpoint = (max = false, min = false) => {
    const { screenSize } = useContext(UserContext);
    const isCorrectBreackpoint = useMemo(() => {
        if (!screenSize) {
            return null;
        }
        if (!min && !max) {
            return true;
        }

        var sortedKeys = Object.keys(breakpoints).sort(function (a, b) {
            return parseInt(breakpoints[a]) - parseInt(breakpoints[b]);
        });

        var minIndex = sortedKeys.indexOf(min);
        var maxIndex = sortedKeys.indexOf(max);

        var screenSizeIndex = sortedKeys.indexOf(screenSize);
        const isMinCorrect = !min || screenSizeIndex >= minIndex;
        const isMaxCorrect = !max || screenSizeIndex < maxIndex;

        return isMinCorrect && isMaxCorrect;
    }, [max, min, screenSize]);

    return isCorrectBreackpoint;
};
